import React from 'react';
import { Card, CardContent, Typography, Divider } from '@mui/joy';

const HubCard = ({ hub }) => (
    <Card variant="outlined">
        <CardContent>
            <Typography level="title-md">{hub.name}</Typography>
            <Typography level="body-sm" textColor="neutral.500">HW ID: {hub.hardware_id}</Typography>
            <Divider sx={{ my: 1 }} />
            <Typography level="body-xs">Hub ID: {hub.id}</Typography>
            <Typography level="body-xs">Log level: {hub.log_level}</Typography>
            <Typography level="body-xs">Created: {new Date(hub.created_at).toLocaleString()}</Typography>
        </CardContent>
    </Card>
);

export default HubCard;
